const { VUE_APP_YAMP_API_URL, VUE_APP_YAMP_PUBLIC_URL } = process.env

export default {
  BASE_URL_API: VUE_APP_YAMP_API_URL,
  BASE_URL_PUBLIC: VUE_APP_YAMP_PUBLIC_URL,
}
